import { TableProps } from 'antd/es/table/InternalTable';
import { Job } from 'types/job';

export const JobsTableProps: TableProps<Job> = {
  bordered: false,
  size: 'large',
  showHeader: true,
  tableLayout: 'auto',
  pagination: false,
  scroll: { x: '100vw' },
  rowSelection: {},
};
